module.exports = __webpack_public_path__ + "static/whitepaper walkthrough-d00cbcd493a0b4a67b0631e4c3c62d90.jpg";